import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './Confirmation.module.scss'

const PrintComponent = ({ t, transId, transOwner }) => {
  const baseURL = process.env.REACT_APP_SERVICE_URL

  const isSafari = useMemo(() => navigator.vendor.indexOf("Apple") !== -1, [])

  const printClick = () => {
    try {
      if (transId && transOwner) {
        window.open(
          `${baseURL}services/transactionservice/api/renderReceipt?transId=${transId}&transOwner=${transOwner}`,
          '_blank',
          'noopener,noreferrer'
        )
      } else {
        console.log(`Empty transId - ${transId} or transOwner - ${transOwner}`)
      }
    } catch (e) {
      console.log(e)
    }
  }

  if (isSafari) {
    return null;
  }

  return (
    <React.Fragment>
      <button
        className={['btn-lg btn-default print_no_display', styles['print_save_margin']].join(' ')}
        value={t('confirmation.print_receipt')}
        name={t('confirmation.print_receipt')}
        onClick={printClick}
      >
        {' '}
        {t('confirmation.print_receipt')}
      </button>
    </React.Fragment>
  )
}

export default withTranslation('common')(PrintComponent)
